import { createPath } from '../_utils/createPath';

export const CHAT_QUERY_KEYS = {
  getDialogs: ['chat', 'get', 'dialogs'],
  getMessages: ['chat', 'get', 'messages'],
  getParticipants: ['chat', 'get', 'participants'],
  getWSEndpoints: ['chat', 'get', 'ws-endpoints'],
};

export const chat = {
  // WebSocket endpoints
  getWSEndpoints: createPath('get_ws_endpoints'),

  // Chat management
  getDialogs: createPath('get_chat?user_id={user_id}'),
  createDialog: createPath('create_chat'),
  editChat: createPath('edit_chat/{chat_id}'),
  deleteChat: createPath('delete_chat/{chat_id}'),

  // Messages
  getMessages: createPath('get_messages/{chat_id}'),
  createMessage: createPath('send_message'),
  editMessage: createPath('edit_message'),
  deleteMessage: createPath('delete_message'),
  readMessage: createPath('read_message/{chat_id}/{message_id}'),

  // Participants & Settings
  getParticipants: createPath('get_participants/{chat_id}'),
  updateUserSettings: createPath('update_user_settings/{chat_id}'),
};
